import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {IconType, IoniconsOutline, ND} from '@pt/pt-models';

export enum LabelItemType {
  STRING = 'STRING',
  DATE = 'DATE',
  ASYNC = 'ASYNC',
}

export interface LabelItemIcon {
  key: IoniconsOutline,
  type: IconType,
  size?: number
}

@Component({
  selector: 'pt-label-item',
  template: `
    <div class='pt-label-item'>
      <pt-icon
        *ngIf='labelItemIcon'
        [key]='labelItemIcon.key'
        [iconType]='labelItemIcon.type'
        [size]='fontSize' [ngClass]='{"cursor-pointer clickable": isClickable}'
        (click)='isClickable ? clickAction.emit(true) : ""'
        container='body'
        placement='left'
        ngbTooltip='{{toolTip}}'
        [tooltipClass]='"pt-label-item-tooltip"'
      ></pt-icon>

      <div class='value' *ngIf='label'
           [ngStyle]='{"font-size": fontSize + "px"}'
           [ngClass]='{"cursor-pointer clickable": isClickable}'
           (click)='isClickable ? clickAction.emit(true) : ""'>
        <ng-container [ngSwitch]='labelItemType'>

          <ng-container *ngSwitchCase="'ASYNC'">
            {{ (label | async) ? (label | async) : ND }}
          </ng-container>

          <ng-container *ngSwitchCase="'DATE'">
            {{ (label | localizedDate: {defaultValue: ND}) }}
          </ng-container>

          <ng-container *ngSwitchDefault>
            {{ label !== null && label !== undefined ? label : ND }}
          </ng-container>

        </ng-container>
      </div>

      <ng-content select='[customLabelWithIcon]'></ng-content>
    </div>

    <div class='pt-label-item' [ngStyle]='{"font-size": fontSize + "px"}'>
      <ng-content select='[customLabel]'></ng-content>
    </div>
  `,
  styleUrls: ['label-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabelItemComponent {
  @Input() label: any;
  @Input() labelItemType: LabelItemType;
  @Input() labelItemIcon: LabelItemIcon;
  @Input() toolTip: string;
  @Input() isClickable: boolean;
  @Input() fontSize = 12;

  @Output() clickAction: EventEmitter<boolean> = new EventEmitter<boolean>();

  public ND = ND;
}
